var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 29,
    viewBox: "0 0 40 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.496094V1.34483V8.13468H1.70213V2.19356H7.65957V0.496094H0.851064H0ZM32.3404 0.496094V2.19356H38.2979V8.13468H40V1.34483V0.496094H39.1489H32.3404ZM3.40426 3.89102V25.1093H5.95745V3.89102H3.40426ZM6.80851 3.89102V25.1093H7.65957V3.89102H6.80851ZM8.93617 3.89102V25.1093H13.1915V3.89102H8.93617ZM14.8936 3.89102V25.1093H15.7447V3.89102H14.8936ZM16.5957 3.89102V25.1093H17.4468V3.89102H16.5957ZM18.2979 3.89102V25.1093H21.7021V3.89102H18.2979ZM22.5532 3.89102V25.1093H23.4043V3.89102H22.5532ZM24.2553 3.89102V25.1093H26.8085V3.89102H24.2553ZM28.5106 3.89102V25.1093H30.2128V3.89102H28.5106ZM31.0638 3.89102V25.1093H31.9149V3.89102H31.0638ZM33.1915 3.89102V25.1093H34.0426V3.89102H33.1915ZM34.8936 3.89102V25.1093H36.5957V3.89102H34.8936ZM0 20.8657V27.6555V28.5043H0.851064H7.65957V26.8068H1.70213V20.8657H0ZM38.2979 20.8657V26.8068H32.3404V28.5043H39.1489H40V27.6555V20.8657H38.2979Z",
    fill: "#1B4597"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeIcon);
export default __webpack_public_path__ + "static/media/barcode_icon.3a521f49c7cf64fdb50facf675f42987.svg";
export { ForwardRef as ReactComponent };